import * as React from "react";
import { useNavigate } from "react-router-dom";
import wbmanual from "../assets/EZYweigh-WB.pdf";
import bomanual from "../assets/EZYweigh-BO.pdf";
import wbicon from "../assets/wbmanual-icon.png";
import boicon from "../assets/backoffice-icon.png";
import { Button } from "@progress/kendo-react-buttons";


const UserManual = () => {
    const navigate = useNavigate();
    if (localStorage.getItem("userid") === null) navigate("/logout");
    

    return (
        <>
            <div className="background-3d" />
            <div className="form-wrapper">
                <div className="row" style={{paddingTop: "50px"} }>
                    <div className="col-md-6">
                        <a href={wbmanual} download="weighbridge-manual" target="_blank" rel="noopener noreferrer">
                            <img src={wbicon} style={{maxWidth: "350px"} } />
                            <Button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">Download Weighbridge Manual</Button>
                        </a>
                    </div>
                    <div className="col-md-6">
                        <a href={bomanual} download="backoffice-manual" target="_blank" rel="noopener noreferrer">
                            <img src={boicon} style={{ maxWidth: "350px" }} />
                            <Button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">Download Back Office Manual</Button>
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
};

export default UserManual;
